export default __webpack_public_path__ + "738cf3b41bfa9151e2553b96c41fd06d.svg";